export default function LogsPage() {
  return (
    <div className="page">
      <header className="page-header">
        <h2>Logs</h2>
        <p className="page-subtitle">Real-time request logs</p>
      </header>
      <div className="placeholder-card">
        <p>Live log streaming coming soon.</p>
      </div>
    </div>
  )
}
